import { useLanguageContext } from '../core/locale/LanguageContext';
import { doTheOldSwitcheroo, env } from '../core/util/env';
import { Brand, getBrandFromUrl } from '../core/context/claims';
import InfoViewText from '../components/InfoViewText/InfoViewText';
import EnrollKlarnaImage from '../components/EnrollKlarnaQR/EnrollKlarnaImage';
import PrimaryButton from '../components/PrimaryButton/PrimaryButton';
import AppStoreLink from '../components/AppStoreLink/AppStoreLink';
import { useNavigation } from '../platform/navigation/useNavigation';
import { useDevice } from '../platform/device/useDevice';

const getVippsRedirectUrl = (): string => {
  const url = new URL(`${env.VITE_LP_SECONDARY_URL}/enrollKlarna`);
  url.searchParams.append('redirectAttempted', 'true');
  return url.href;
};

const getEnrollKlarnaDeeplinkUrl = (brand: Brand, currentUrl: URL) => {
  return brand === 'VIPPS' ? getVippsRedirectUrl() : doTheOldSwitcheroo(currentUrl);
};

const EnrollKlarnaView = () => {
  const navigation = useNavigation();
  const brand = getBrandFromUrl();
  const currentUrl = navigation.getCurrentUrl();
  const hasAttemptedRedirect = currentUrl.searchParams.get('redirectAttempted') === 'true';
  const languageContext = useLanguageContext();
  const deeplinkUrl = getEnrollKlarnaDeeplinkUrl(brand, currentUrl);
  const isOnMobile = useDevice().isMobile;
  return isOnMobile ?
      <div style={{ marginTop: '20px', flexDirection: 'column', display: 'flex' }}>
        <InfoViewText title={languageContext.getLocalizedText('addKlarna')} bold={true} />
        <EnrollKlarnaImage />
        {hasAttemptedRedirect ?
          <AppStoreLink brand={brand} locale={languageContext.locale} />
        : <PrimaryButton
            onClick={() => window.open(deeplinkUrl, '_parent')}
            loading={false}
            disabled={false}
            aria-label={languageContext.getLocalizedText('openVipps')}
          >
            {languageContext.getLocalizedText('openVipps')}
          </PrimaryButton>
        }
      </div>
    : <>
        <InfoViewText title={languageContext.getLocalizedText('scanToOpenInKlarna')} bold={true} />
        <EnrollKlarnaImage />
        {hasAttemptedRedirect ?
          <></>
        : <a className="cancel-link" href={deeplinkUrl} role="button">
            {languageContext.getLocalizedText('openInKlarnaMobileText')}
          </a>
        }
      </>;
};

export default EnrollKlarnaView;
